// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__8k96J","lateralPanel":"Panel_lateralPanel__1mctx"};